module.exports = __webpack_public_path__ + "static/media/goals_stats.dbf45a6c.svg";